module.exports = __webpack_public_path__ + "img/vehicle_type.421c3744.svg";